var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 5C15.2129 5 5 15.2129 5 27.75C5 40.2871 15.2129 50.5 27.75 50.5C40.2871 50.5 50.5 40.2871 50.5 27.75C50.5 15.2129 40.2871 5 27.75 5ZM27.75 8.5C38.4004 8.5 47 17.0996 47 27.75C47 38.4004 38.4004 47 27.75 47C17.0996 47 8.5 38.4004 8.5 27.75C8.5 17.0996 17.0996 8.5 27.75 8.5ZM37.0059 19.5195L24.25 32.2754L18.4805 26.5195L16.0195 28.9805L24.25 37.2246L39.4941 21.9805L37.0059 19.5195Z",
    fill: "#00CE3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.e1f2625948d6e75034857a6a93a2278e.svg";
export { ForwardRef as ReactComponent };